import { render } from "./user-notifications.vue?vue&type=template&id=8e2e9b16"
import script from "./user-notifications.vue?vue&type=script&lang=js"
export * from "./user-notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__